<template>
  <div>
    <label for="planning-week">{{ $t('insights.ui.timespan.label') }}</label>
    <select name="" class="form-control" id="planning-week" v-model="config.weekDifference">
      <option :value="-1">{{ $t('insights.ui.timespan.lastWeek') }}</option>
      <option :value="0">{{ $t('insights.ui.timespan.currentWeek') }}</option>
      <option :value="1">{{ $t('insights.ui.timespan.nextWeek') }}</option>
      <option :value="2">{{ $t('insights.ui.timespan.afterNextWeek') }}</option>
    </select>
  </div>
</template>

<script>

export default {
  mixins: [],
  name: "WeekSelect",
  props: ['editing', 'config'],
  data() {
    return {}
  }
}
</script>

<style scoped>

</style>